import api from './api';

const base = (tenantId) => `/api/community-news/${tenantId}`;

// ── Feed (member read) ────────────────────────────────────────────────────────
export const getPosts     = (tenantId, params) => api.get(`${base(tenantId)}/posts`, { params });
export const getPostById  = (tenantId, id)     => api.get(`${base(tenantId)}/posts/${id}`);
export const getTags      = (tenantId)          => api.get(`${base(tenantId)}/tags`);

// ── Social ────────────────────────────────────────────────────────────────────
export const toggleLike  = (tenantId, id)              => api.post(`${base(tenantId)}/posts/${id}/like`);
export const addComment  = (tenantId, id, content)     => api.post(`${base(tenantId)}/posts/${id}/comment`, { content });

// ── Manager ───────────────────────────────────────────────────────────────────
export const getAdminPosts = (tenantId, params)     => api.get(`${base(tenantId)}/admin-posts`, { params });
export const createPost    = (tenantId, data)        => api.post(`${base(tenantId)}/posts`, data);
export const updatePost    = (tenantId, id, data)    => api.put(`${base(tenantId)}/posts/${id}`, data);
export const deletePost    = (tenantId, id)          => api.delete(`${base(tenantId)}/posts/${id}`);
